import { API } from "../../../utils";

export const futureCostsApi = async (params) => {
  const response = await API.get("ingredient-future-costing", { params });
  return response.data;
};

export const costChangeHistoryApi = async (id, params) => {
  const response = await API.get(`ingredient-cost-change-history/${id}`, {
    params,
  });
  return response.data;
};

export const createFutureCostApi = async (data) => {
  const response = await API.post("ingredient-future-costing", data);
  return response.data;
};

export const updateFutureCostApi = async ({ id, payload }) => {
  const response = await API.post(`ingredient-future-costings/${id}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteFutureCostApi = async (data) => {
  const response = await API.post("ingredient-future-costing/delete", data);
  return response.data;
};

export const downloadFutureCostTemplateApi = async () => {
  const response = await API.get(
    "ingredient-future-costing/template/download",
    {
      responseType: "blob",
    },
  );
  return response;
};

export const importFutureCostApi = async (data) => {
  const response = await API.post("ingredient-future-costing/import", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
